/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.repeatable-booking', []);
